import React, { useEffect, useState } from 'react';
import { supabase } from '../../lib/supabase';
import { AnimatedNumber } from './StatsBand';

interface ParticipationStats {
  total_votes: number;
  total_voters: number;
  countries: number;
  regions: number;
  institutions: number;
}

/** Solo la cuadrícula de cifras animadas: el contenedor (caja, cabecera,
 * botones...) lo pone quien la use, para poder fusionarla con otras
 * secciones sin arrastrar su propio título ni fondo. */
const ParticipationStatsBand: React.FC<{ candidaturas?: number }> = ({ candidaturas }) => {
  const [stats, setStats] = useState<ParticipationStats | null>(null);

  useEffect(() => {
    let cancelled = false;
    supabase
      .schema('premios')
      .rpc('get_public_participation_stats')
      .then(({ data }) => {
        if (cancelled) return;
        setStats((data as ParticipationStats) || null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!stats) return null;

  const items: { value: number; label: string }[] = [
    ...(candidaturas ? [{ value: candidaturas, label: 'Candidaturas recibidas' }] : []),
    { value: stats.total_votes, label: 'Votos del público' },
    { value: stats.total_voters, label: 'Personas han votado' },
    { value: stats.institutions, label: 'Instituciones distintas' },
    { value: stats.regions, label: 'Comunidades autónomas' },
    { value: stats.countries, label: 'Países' },
  ];

  return (
    <div className="landing-stats-grid landing-participation-grid" aria-label="Cifras récord de participación">
      {items.map((s, i) => (
        <div key={i} className="landing-stat">
          <div className="landing-stat-value">
            <AnimatedNumber target={s.value} plain={String(s.value)} />
          </div>
          <div className="landing-stat-label">{s.label}</div>
        </div>
      ))}
    </div>
  );
};

export default ParticipationStatsBand;
